/**
 *
 * Cache component
 * 
 * This component is used to avoid browsers cache to serve obsolete
 * pages to the users.
 * It requires a `meta.json` file in the public folder,
 * with the current code version; for example:
 * {"version":"1.0.0"}
 * To use it, simply wrap JSX in top level component (usually `App.js`)
 * with <Cache></Cache>
 * At run time, when the main page is loaded, the cache code will run,
 * and it will issue a forced page reload if version found in `meta.json`
 * (which is never cached) is greather than code version
 * (as from `package.json`).
 * 
 */

import React from 'react'
import packageJson from '../package.json'
global.appVersion = packageJson.version

export default class Cache extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: () => {
        console.log(`* Cache - refreshCacheAndReload() - clearing cache and hard reloading...`)
        if (caches) {
          // service worker cache should be cleared with caches.delete()
          caches.keys().then(function(names) {
            for (let name of names) caches.delete(name);
          });
        }
        // delete browser cache and hard reload
        window.location.reload(true);
      }
    };
  }

  componentDidMount() {
    //fetch('./meta.json')
    fetch(`./meta.json?${new Date().getTime()}`, { cache: 'no-cache' }) // just to be sure this file is not cached
      .then((response) => response.json())
      .then((meta) => {
        const latestVersion = meta.version;
        const currentVersion = global.appVersion;

        const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
        if (shouldForceRefresh) {
          console.log(`* Cache - we have a new version: ${latestVersion}, should force refresh`);
          this.setState({ loading: false, isLatestVersion: false });
        } else {
          console.log(`* Cache - we already have the latest version: ${latestVersion}, (current version is ${currentVersion}), no cache refresh needed`);
          this.setState({ loading: false, isLatestVersion: true });
        }
      })
      .catch((error) => {
        console.error(`* Cache - error fetching meta.json, proceeding without version check:`, error);
        // In case of error, proceed with loading the app anyway
        this.setState({ loading: false, isLatestVersion: true });
      })
    ;
  }

  render() {
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
    return this.props.children({ loading, isLatestVersion, refreshCacheAndReload });
  }
}

/**
 *
 * @param versionA (from `meta.json` file, latest version)
 * @param versionB (from bundle file, current version)
 * 
 * @return true if version A is greater than version B
 *
 */
const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g);
  const versionsB = versionB.split(/\./g);

  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());
    const b = Number(versionsB.shift());
    // eslint-disable-next-line no-continue
    if (a === b) continue;
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b);
  }
  return false;
}


// WEBPACK FOOTER //
// ./src/Cache.js